import {
  BUTTON_WIDTH,
  BUTTON_HEIGHT,
  BUTTON_COLOR,
} from "@bitComponents/unifiedComponents/Button";

export const URLS = {
  URL_TRACKING_CO: "https://www.movistar.es/area-cliente/mi-perfil/seguimiento-de-pedidos/",
  MY_PRODUCTS: "https://www.movistar.es/area-cliente/mis-productos/",
  HOME: "https://www.movistar.es/particulares",
  VTL_CATALOG: "https://www.movistar.es/moviles",
  PACK_CONFIG: "https://www.movistar.es/fibra-y-movil",
  BAF_TARIFF_LIST: "https://www.movistar.es/internet",
  MOBILE_TARIFF_LIST: "https://www.movistar.es/tarifas-moviles",
  MOBILE_TARIFF_LME_LIST: "https://www.movistar.es/tarifas-moviles/lineas-adicionales",
  SELF_EMPLOYED_MOBILE_TARIFF_LIST: "https://www.movistar.es/autonomos/tarifas-movil/datos-ilimitados",
  SELF_EMPLOYED_MOBILE_TARIFF_LME_LIST: "https://www.movistar.es/autonomos/tarifas-movil/linea-movil-adicional",
  MOVISTAR_PLUS: "https://www.movistarplus.es/",
  SEARCH_SHOP: "https://tiendas.movistar.es/",
  BOOK_SHOP_APPOINTMENT: "https://appweb.movistar.es/pages/appointment-booking",
  URL_PACKS: "https://www.movistar.es/moviles/?sort=relevance&tags=PACK",
  MY_PROFILE: "https://www.movistar.es/area-cliente/mi-perfil/",
  DEFAULT_OBD_URL: "https://www.movistar.es/area-cliente/mi-perfil/verificacion-avanzada/inicio?forzarOBD=true&destino=medios-contacto",
};

export const PHONE_900_OPERATION_NOT_AUTHORIZED = "900 181 004";
export const PHONE_900 = "900 104 430";
export const PHONE_1004 = "1004";

export const mobileTariffs = {
  showListButton: [
    {
      label: "Ver tarifas móviles Movistar",
      link: URLS.MOBILE_TARIFF_LIST,
      color: BUTTON_COLOR.BLUE,
      desktopProps: {
        size: {
          w: BUTTON_WIDTH.LIQUID_DOPPED,
          h: BUTTON_HEIGHT.REGULAR,
        },
      },
    },
  ],
};

export const bafTariffs = {
  showListButton: {
    label: "Ver otras tarifas",
    link: URLS.BAF_TARIFF_LIST,
    desktopProps: {
      size: {
        w: BUTTON_WIDTH.LIQUID_DOPPED,
        h: BUTTON_HEIGHT.REGULAR,
      },
    },
    color: BUTTON_COLOR.WHITE_BLUE,
  },
};

export const CALL_GENERIC_900 = {
  label: `Llama gratis al ${PHONE_900}`,
  link: `tel:${PHONE_900.replace(/\s/g, "")}`,
  forceExternal: true,
  desktopProps: {
    size: {
      w: BUTTON_WIDTH.LIQUID_DOPPED,
      h: BUTTON_HEIGHT.REGULAR,
    },
    hide: true,
  },
  tabletProps: {
    hide: true,
  },
  color: BUTTON_COLOR.BLUE,
};

export const CALL_GENERIC_1004 = {
  label: `Llama gratis al ${PHONE_1004}`,
  link: `tel:${PHONE_1004.replace(/\s/g, "")}`,
  forceExternal: true,
  desktopProps: {
    size: {
      w: BUTTON_WIDTH.LIQUID_DOPPED,
      h: BUTTON_HEIGHT.REGULAR,
    },
    hide: true,
  },
  tabletProps: {
    hide: true,
  },
  color: BUTTON_COLOR.BLUE,
};

export const DEBT_PAYMENT = {
  label: "Consultar facturas",
  link: "https://www.movistar.es/cliente/areaprivada/#/debtPayment",
  forceExternal: true,
  desktopProps: {
    size: {
      w: BUTTON_WIDTH.LIQUID_DOPPED,
      h: BUTTON_HEIGHT.REGULAR,
    },
  },
  color: BUTTON_COLOR.BLUE,
};

export const ONBOARDING_PROCESS = {
  label: "Verificar identidad",
  link: "https://www.movistar.es/area-cliente/mi-perfil/verificacion-avanzada/inicio?forzarOBD=true&destino=medios-contacto",
  forceExternal: true,
  desktopProps: {
    size: {
      w: BUTTON_WIDTH.LIQUID_DOPPED,
      h: BUTTON_HEIGHT.REGULAR,
    },
  },
  color: BUTTON_COLOR.BLUE,
};

export const PACK_BUTTONS = {
  goToPackConfigChangingZone: {
    color: BUTTON_COLOR.BLUE,
    onClick: () => {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const zipCode = urlParams.get("zipCode");
      const newZipCode = zipCode === "libre" ? "regulada" : "libre";
      urlParams.set("zipCode", newZipCode);
      urlParams.set("shoppingCart", "true");
      window.location.href = `${URLS.PACK_CONFIG}?${urlParams.toString()}`;
    },
    label: "Aceptar",
    desktopProps: {
      size: {
        w: BUTTON_WIDTH.LIQUID_DOPPED,
        h: BUTTON_HEIGHT.REGULAR,
      },
    },
  },
  seeOtherPackConfigProducts: {
    label: "Ver otros productos",
    color: BUTTON_COLOR.BLUE,
    link: URLS.PACK_CONFIG,
    desktopProps: {
      size: {
        w: BUTTON_WIDTH.LIQUID_DOPPED,
        h: BUTTON_HEIGHT.REGULAR,
      },
    },
  },
  goBackPackConfig: {
    label: "Volver al configurador",
    color: BUTTON_COLOR.BLUE,
    link: URLS.PACK_CONFIG,
    desktopProps: {
      size: {
        w: BUTTON_WIDTH.LIQUID_DOPPED,
        h: BUTTON_HEIGHT.REGULAR,
      },
    },
  },
  callPhoneOperationNotAuthorized: {
    color: BUTTON_COLOR.BLUE_REVERSE,
    link: `tel:${PHONE_900_OPERATION_NOT_AUTHORIZED.replace(/\s/g, "")}`,
    forceExternal: true,
    label: `Llamar gratis al ${PHONE_900_OPERATION_NOT_AUTHORIZED}`,
    desktopProps: {
      size: {
        w: BUTTON_WIDTH.LIQUID_DOPPED,
        h: BUTTON_HEIGHT.REGULAR,
      },
      hide: true,
    },
    tabletProps: {
      hide: true,
    },
  },
};
